import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'ProductIdDisplay',
        caption: 'Product',
        width: COLUMN_SIZE.lg0
    },
    {
        dataField: 'ProductId',
        caption: 'ProductId',
        visible: false
    },
    {
        dataField: 'LineNumber',
        caption: 'LineNumber',
        visible: false
    },
    {
        dataField: 'OrderedQuantity',
        caption: 'Ordered',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'BackorderedQuantity',
        caption: 'On Order',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'SuppliedQuantity',
        caption: 'Supplied',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        allowEditing: false,
        alignment: 'right'
    },
    {
        dataField: 'Price',
        caption: 'Price',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'BuyingUnit',
        caption: 'Unit',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        allowSorting: false,
        allowEditing: false
    },
    {
        dataField: 'SupplierProduct',
        caption: 'Supplier Product',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        allowSorting: false,
        isEditable: true,
    },
    {
        dataField: 'DueDate',
        caption: 'Due',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        allowSorting: false,
        isEditable: true,
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.lg0,
        allowSorting: false,
        allowEditing: false,
    }
];

export const FieldName = {
    quantity: 'OrderedQuantity',
    product: 'Product',
    price: 'Price',
};

export const FastEntryEnabledStatus = ['Preparing', 'Modifying'] as const;
